import axios from 'axios'; 

export const getAdminData = async () => {
  try {
    const response = await axios.get(`jupiterdata/GetAdminData`);
    return response.data;
  } catch (error) {
    console.error('Error fetching admin data:', error);
    throw error;
  }
};

export const checkDuplicateEmail = async (emailId) => {
  try {
    const data = await getAdminData();
    return data.some(user => user.emailId.toLowerCase() === emailId.toLowerCase());
  } catch (error) {
    console.error('Error checking duplicate email:', error);
    throw error;
  }
};

export const deleteUser = async (userId, emailId) => {
  try {
    const response = await axios.get(`jupiterdata/DeleteUser/${userId}/${emailId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};


export const updateUser = async (userPayload) => {
  try {
    const response = await axios.post(
      "/jupiterdata/InsertUpdateUser",
      userPayload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error.response || error.message);
    throw error;
  }
};

export const getRoles = async () => {
  try {
    const response = await axios.get(`jupiterdata/GetDropdownData/Role`);
    return response.data;
  } catch (error) {
    console.error('Error fetching admin data:', error);
    throw error;
  }
};

export const getBusiness = async () => {
  try {
    const response = await axios.get(`jupiterdata/GetDropdownData/Business`);
    return response.data;
  } catch (error) {
    console.error('Error fetching admin data:', error);
    throw error;
  }
};